var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#DD1A00",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2719 22.5C32.2719 20.5673 31.6987 18.6799 30.6266 17.0734C29.5513 15.4669 28.0255 14.2156 26.2414 13.4761C24.4573 12.7366 22.4923 12.5429 20.5968 12.9207C18.7013 13.2969 16.9608 14.2285 15.5948 15.5944C14.2289 16.9604 13.2989 18.7009 12.9227 20.5964C12.5449 22.4919 12.7386 24.4553 13.4765 26.2394C14.2176 28.0251 15.4689 29.5509 17.0738 30.623C18.6819 31.6967 20.571 32.2698 22.502 32.2698C25.0918 32.2666 27.575 31.2365 29.406 29.4056C31.2385 27.5746 32.267 25.0914 32.2719 22.5016V22.5Z",
    stroke: "#DD1A00",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2734 19.2705L25.7318 25.7288",
    stroke: "#DD1A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7318 19.2705L19.2734 25.7288",
    stroke: "#DD1A00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancle);
export default __webpack_public_path__ + "static/media/cancle.09235b6033f827739aa0ca29cc56a651.svg";
export { ForwardRef as ReactComponent };